export class AccountWorkflow {
    taskId: string;
    accountId: string;
    userId: string;
    accountStatusCode: string;
    comment: string;
}




// WEBPACK FOOTER //
// ./src/app/models/accountWorkflow.ts